interface PodcastIconProps {
  size?: number;
  color?: string;
  className?: string; // Added className prop for Tailwind support
}

export function PodcastIcon({ size = 64, color = '#E1591B', className }: PodcastIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Microphone body */}
      <path
        d="M32 8C28.6863 8 26 10.6863 26 14V28C26 31.3137 28.6863 34 32 34C35.3137 34 38 31.3137 38 28V14C38 10.6863 35.3137 8 32 8Z"
        fill={color}
      />
      
      {/* Microphone grille lines */}
      <line x1="29" y1="16" x2="35" y2="16" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <line x1="29" y1="20" x2="35" y2="20" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      <line x1="29" y1="24" x2="35" y2="24" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
      
      {/* Microphone stand base */}
      <path
        d="M32 34V46M24 46H40"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Sound wave arc - left side */}
      <path
        d="M20 20C20 16.6863 21.7909 13.7864 24.4721 12"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M16 22C16 16.2174 18.9491 11.1429 23.4 8"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.5"
      />
      
      {/* Sound wave arc - right side */}
      <path
        d="M44 20C44 16.6863 42.2091 13.7864 39.5279 12"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M48 22C48 16.2174 45.0509 11.1429 40.6 8"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.5"
      />
      
      {/* Connection nodes - representing CRM/networking */}
      <circle cx="52" cy="36" r="3" fill={color} opacity="0.8" />
      <circle cx="58" cy="28" r="2.5" fill={color} opacity="0.6" />
      <circle cx="12" cy="36" r="3" fill={color} opacity="0.8" />
      <circle cx="6" cy="28" r="2.5" fill={color} opacity="0.6" />
      
      {/* Connection lines */}
      <path
        d="M38 28L49 33"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.4"
        strokeDasharray="2 2"
      />
      <path
        d="M50 33L56 29"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.4"
        strokeDasharray="2 2"
      />
      <path
        d="M26 28L15 33"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.4"
        strokeDasharray="2 2"
      />
      <path
        d="M14 33L8 29"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.4"
        strokeDasharray="2 2"
      />
    </svg>
  );
}
